import { render, staticRenderFns } from "./ProductNameEdit.vue?vue&type=template&id=371d9624&scoped=true&"
import script from "./ProductNameEdit.vue?vue&type=script&lang=js&"
export * from "./ProductNameEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371d9624",
  null
  
)

export default component.exports